import React from 'react';
import * as AuthActions from 'core/services/store/auth/actions';
import AuthServices from 'core/services/store/auth/services';
import { $, StarberryComponentContext } from '@starberry/components';
import { Icon } from '@chakra-ui/react';
import { Routes } from '../../routes';

export const LoginFormAuth = {
  component: 'form',
  provide: ['auth'],
  props: {
    key: 'login-form',
    flex: 1,
    onSubmit: (_, context) => (e) => {
      const [state, dispatch] = context?.state?.auth || [];
      e.preventDefault();
      AuthServices(dispatch, AuthActions)
        .registerWithEmail({
          forename: state?.form?.forename,
          surname: state?.form?.surname,
          email: state?.form?.email,
          password: state?.form?.password,
        })
        .then(() => {
          window.location.href = Routes[context.constants.indexPage];
        })
        .catch(() => {});
    },
  },
};

const EmailIcon = (props) => {
  const { constants } = React.useContext(StarberryComponentContext);
  return <Icon as={constants.icons.emailInput} color="inherit" {...props} />;
};

const LoginForm = {
  $: LoginFormAuth,
  submitButton: {
    $: 'PrimaryButton',
    type: 'submit',
    children: $('constants.translations.login.SIGNUP_SUBMIT_BTN', 'Continue'),
  },
  children: [
    {
      $: 'Flex',
      provide: ['auth'],
      children: (_, context) => {
        const [state] = context?.state?.auth || [];
        return {
          $: 'Alert',
          props: {
            status: 'error',
            display: state?.error ? 'flex' : 'none',
            mb: state?.error ? 6 : 0,
            borderRadius: $('constants.input.borderRadius'),
          },
          children: [
            { $: 'AlertIcon' },
            {
              $: 'AlertTitle',
              props: { mr: 2 },
              children: state?.message?.message,
            },
          ],
        };
      },
    },
    {
      $: 'Stack',
      props: {
        spacing: 6,
      },
      $children: [
        {
          $: 'FormControl',
          props: {
            id: 'signup-forename',
            key: 'signup-forename',
          },
          children: [
            {
              $: 'InputField',
              provide: ['auth'],
              props: {
                type: 'text',
                label: 'First name',
                name: 'forename',
                value: (_, context) => {
                  const [state] = context?.state?.auth || [];
                  return state?.form?.forename;
                },
                onChange: (_, context) => {
                  const [, dispatch] = context?.state?.auth || [];
                  return (e) => {
                    dispatch(AuthActions.setFormField('forename', e.target.value));
                  };
                },
              },
            },
          ],
        },
        {
          $: 'FormControl',
          props: {
            id: 'signup-surname',
            key: 'signup-surname',
          },
          children: [
            {
              $: 'InputField',
              provide: ['auth'],
              props: {
                label: 'Surname',
                name: 'surname',
                value: (_, context) => {
                  const [state] = context?.state?.auth || [];
                  return state?.form?.surname;
                },
                onChange: (_, context) => {
                  const [, dispatch] = context?.state?.auth || [];
                  return (e) => {
                    dispatch(AuthActions.setFormField('surname', e.target.value));
                  };
                },
              },
            },
          ],
        },
        {
          $: 'FormControl',
          props: {
            id: 'email',
            key: 'email',
          },
          children: [
            {
              $: 'InputField',
              provide: ['auth'],
              props: {
                name: 'email',
                label: 'Email address',
                type: 'email',
                autoComplete: 'email',
                required: true,
                onChange: (_, context) => {
                  return (e) => {
                    const [, dispatch] = context?.state?.auth ?? [];
                    dispatch(AuthActions.setFormField('email', e.target.value));
                  };
                },
                value: (_, context) => {
                  const [state] = context?.state?.auth || [];
                  return state?.form?.email;
                },
                rightIcon: () => EmailIcon,
              },
            },
          ],
        },
        {
          $: 'FormControl',
          props: {
            id: 'passsword',
            key: 'passsword',
          },
          children: [
            {
              $: 'InputField',
              provide: ['auth'],
              props: {
                type: 'password',
                label: 'Password',
                value: (_, context) => {
                  const [state] = context?.state?.auth || [];
                  return state?.form?.password;
                },
                onChange: (_, context) => {
                  const [, dispatch] = context?.state?.auth || [];
                  return (e) => {
                    dispatch(AuthActions.setFormField('password', e.target.value));
                  };
                },
              },
            },
          ],
        },
        $('submitButton'),
      ],
    },
  ],
};

export default LoginForm;
